(function() {
    'use strict';
    angular
        .module('showcaseApp')
        .component('funnelNegotiationCard', {
            bindings: {
                negotiation: '<',
                column: '=',
                columns: '=',
                actions: '<'
            },
            controller: FunnelNegotiationCardController,
            controllerAs: 'vm',
            templateUrl: 'app/admin/sales-funnel/components/negotiation-card/negotiation-card.html'
        });

    /** @ngInject */
    function FunnelNegotiationCardController($uibModal, $rootScope, moment, $localStorage, StoreService, FlyersService,
                                             $translate, $window, systemConstants, $scope) {
        var vm = this;

        vm.TRUNCATE_THRESHOLD = 30;
        var DATE_FORMAT = $translate.instant('dateTimeMinutesFormat');
        vm.isMobile = $window.innerWidth < systemConstants.BOOTSTRAP_RESOLUTIONS.MIN_SM;
        vm.productResolved = false;
        vm.dateToShowFormatted = moment(vm.negotiation.createdDate).format(DATE_FORMAT);

        vm.$onInit = function () {
            vm.negotiation.column = vm.column;
        }

        $scope.$watchGroup(
            [
                function () {
                    return vm.negotiation && vm.negotiation.productId;
                },
                function () {
                    return vm.negotiation && vm.negotiation.product && vm.negotiation.product.name;
                }
            ],
            function (newVals) {
                var productId = newVals[0];
                var productName = newVals[1];

                if (!vm.negotiation || vm.productResolved) {
                    return;
                }

                if (productName) {
                    vm.negotiation.productName = productName;
                    vm.productResolved = true;
                } else if (productId) {
                    FlyersService.getFlyer(productId).then(function (resp) {
                        vm.negotiation.productName = resp.data.name;
                        vm.productResolved = true;
                    });
                }
            }
        );

        vm.formatMoney = function (value) {
            var currencyConfigurations = $localStorage.defaultStore.storeInfo.currencyConfiguration;
            if(!currencyConfigurations) {
                return
            }
            if (!value) {
                return $translate.instant('salesFunnel.label.no-price');
            }
            return formatMoney(value, currencyConfigurations.prefix, currencyConfigurations.decimalQuant,
                currencyConfigurations.centsSeparator, currencyConfigurations.thousandsSeparator);
        };

        vm.truncateText = function (text, size) {
            if (!text) {
                return '';
            }
            if (text.length > size) {
                return text.substring(0, size) + '...';
            }
            return text;
        };

        vm.handleClick = function (method, actionsArguments) {
            if (method !== undefined && vm.isMobile) {
                if (actionsArguments !== undefined && actionsArguments.constructor !== Array) {
                    actionsArguments = [actionsArguments];
                }
                method.apply(undefined, actionsArguments);
            }
        }
    }
})();

